import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from './swal';
import RoadiesShell from './RoadiesShell';
import { GameHead, TopBar, useSaveScore } from './common';
import { useGameTimer, useRotateNotice } from './hooks';

const OPTIONS = [
  { value: '377', label: '377' },
  { value: '323', label: '323' },
  { value: '257', label: '257' },
];
const CORRECT = '323';

// s4.php: crack the plate-count puzzle. Same select -> reveal -> score pattern as stage 3.
function Stage4Game() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const game = useSelector((s) => s.roadies.game);
  const rotate = useRotateNotice();
  const timer = useGameTimer(true, game?.time);
  const save = useSaveScore();

  const base = game?.totalScore || 0;
  const [points, setPoints] = useState(base);
  const [selected, setSelected] = useState('');
  const [revealed, setRevealed] = useState(false);
  const busy = useRef(false);

  const cls = (v) => {
    if (!revealed) return v === selected ? 'rd-option pending' : 'rd-option';
    if (v === CORRECT) return 'rd-option correct';
    if (v === selected) return 'rd-option wrong';
    return 'rd-option';
  };

  const submit = async () => {
    if (busy.current) return;
    if (!selected) {
      Swal.fire('', 'Please select an option', 'info');
      return;
    }
    busy.current = true;
    setRevealed(true);
    const won = selected === CORRECT;
    const score = base + (won ? 1 : 0);
    setPoints(score);
    setTimeout(async () => {
      const state = await save(4, score, timer.current());
      if (state) navigate({ pathname: '/stage5', search });
      else busy.current = false;
    }, 2000);
  };

  return (
    <>
      {rotate && <div className="rd-rotate">Please rotate your device for the best experience</div>}
      <TopBar time={timer.text} points={points} />
      <GameHead title="Denmark" note="(Select the correct option from the three)">
        Danes also break plates as a gesture of good luck. Crack the puzzle to identify how many plates
        Peter is going to crack on his neighbours' door this year.
      </GameHead>
      <div className="rd-game">
        <div className="rd-spain" style={{ alignItems: 'center' }}>
          <div className="rd-spain-col"><img src="/roadies/img/denmark-left.png" alt="Denmark" /></div>
          <div className="rd-spain-col"><img src="/roadies/img/plate.gif" alt="Plates" /></div>
        </div>
        <div className="rd-options">
          {OPTIONS.map((o) => (
            <div key={o.value} className={cls(o.value)} onClick={() => !revealed && setSelected(o.value)}>
              {o.label}
            </div>
          ))}
        </div>
        <div>
          <button type="button" className="rd-btn" onClick={submit} disabled={revealed}>Submit</button>
        </div>
      </div>
    </>
  );
}

export default function RoadiesStage4() {
  return (
    <RoadiesShell bg="denmark.jpg" bgMob="denmark-mob.jpg" stage={4} className="rd-stage rd-stage4">
      <Stage4Game />
    </RoadiesShell>
  );
}
